module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    staticClass: "relative"
  }, [_c('legend', [_vm._v("Consignment Note #" + _vm._s(_vm.index + 1))]), _vm._v(" "), (_vm.canDelete) ? _c('ladda-button', {
    staticClass: "btn-circle btn-remove-docket",
    attrs: {
      "on-click": _vm.handleDeleteDocket,
      "type": "danger"
    }
  }, [_c('i', {
    staticClass: "fa fa-trash"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group-outer"
  }, [_c('div', {
    staticClass: "form-group float-label-control float-label-no-animation"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("File Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-sm-6 col-md-8': _vm.notDisabled, 'col-sm-12': _vm.disabled
    }
  }, [_c('div', {
    staticClass: "form-group float-label-control float-label-no-animation"
  }, [_c('label', {
    staticClass: "select-label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("File")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.file
    }
  })])]), _vm._v(" "), (_vm.notDisabled) ? _c('div', {
    staticClass: "col-sm-6 col-md-4"
  }, [_c('label', {
    staticClass: "btn btn-primary btn-sm btn-block m-b-md",
    attrs: {
      "for": ("docket-" + (_vm.identifiers.index))
    }
  }, [_c('input', {
    staticClass: "sr-only",
    attrs: {
      "type": "file",
      "name": "file",
      "id": ("docket-" + (_vm.identifiers.index)),
      "accept": ".jpg,.jpeg,.png,.gif"
    },
    on: {
      "change": _vm.handleFileSelection
    }
  }), _vm._v("\n        Select File\n      ")])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-816d23ce"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loads/weighbridge/WeighbridgeConsignmentItem.vue
// module id = 1058
// module chunks = 0